module.exports = __webpack_public_path__ + "static/img/cMRI1.377445f8.png";